module.exports = __webpack_public_path__ + "static/media/vibrant-thumbnail.b62725e9.png";